import { compose, setDisplayName, withHandlers, withProps } from "recompose";

export default compose(
  setDisplayName("NextForm"),
  withProps({
    inputs: {}
  }),
  withHandlers(() => {
    return {
      focusNextField: ({ inputs }) => id => ev => {
        if (ev.key === "Enter") {
          ev.preventDefault();
          if (inputs[id]) {
            inputs[id].focus();
          }
        }
      },
      setInputRef: ({ inputs }) => field => input => {
        inputs[field] = input;
      }
    };
  })
);
